import { render, staticRenderFns } from "./aboutBenZ.vue?vue&type=template&id=1242752f&scoped=true&"
import script from "./aboutBenZ.vue?vue&type=script&lang=js&"
export * from "./aboutBenZ.vue?vue&type=script&lang=js&"
import style0 from "./aboutBenZ.vue?vue&type=style&index=0&id=1242752f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242752f",
  null
  
)

export default component.exports